import { render, staticRenderFns } from "./followUpPersonnel.vue?vue&type=template&id=31242409&scoped=true"
import script from "./followUpPersonnel.vue?vue&type=script&lang=js"
export * from "./followUpPersonnel.vue?vue&type=script&lang=js"
import style0 from "./followUpPersonnel.vue?vue&type=style&index=0&id=31242409&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31242409",
  null
  
)

export default component.exports